export default "./images/survio-1Ia2j-assets-increase-team.png";